import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import axios from "axios";
import { AuthContext, base_url } from "../../../context/Authcontext";
import _ from 'lodash';

// Skeleton Components
const SkeletonCard = () => (
  <div className="card mb-3 shadow-sm">
    <div className="card-header bg-light">
      <div className="skeleton-line" style={{ width: '70%', height: '20px' }}></div>
    </div>
    <div className="card-body">
      <div className="d-flex justify-content-between mb-2">
        <div className="skeleton-line" style={{ width: '40%', height: '16px' }}></div>
        <div className="skeleton-line" style={{ width: '20%', height: '16px' }}></div>
      </div>
      <div className="d-flex justify-content-between">
        <div className="skeleton-line" style={{ width: '40%', height: '16px' }}></div>
        <div className="skeleton-line" style={{ width: '20%', height: '16px' }}></div>
      </div>
    </div>
  </div>
);

const FancySkeleton = () => (
  <div className="card mb-3 shadow-sm">
    <div className="card-header bg-light">
      <div className="skeleton-line" style={{ width: '60%', height: '20px' }}></div>
    </div>
    <div className="card-body d-flex justify-content-between">
      <div className="skeleton-line" style={{ width: '50%', height: '16px' }}></div>
      <div className="skeleton-line" style={{ width: '15%', height: '16px' }}></div>
    </div>
  </div>
);

const MarketAnalysis = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const [loading, setLoading] = useState(true);
  const [lockedMatch, setLockedMatch] = useState([]);
  const [lockedMatchesLoaded, setLockedMatchesLoaded] = useState(false);
  const [cricket, setCricket] = useState([]);
  const [betcricketMatch, setBetCricketMatch] = useState([]);
  const [betfancytMatch, setBetFancyMatch] = useState([]);

  const compareWithToday = (eventDate, allEvents) => {
    const now = new Date();
    const eventDateObj = new Date(eventDate);

    // Convert both to local date strings (YYYY-MM-DD) for comparison
    const todayDate = now.toISOString().split("T")[0];
    const eventDateFormatted = eventDateObj.toISOString().split("T")[0];

    // Get time in minutes since midnight
    const currentMinutes = getMinutesSinceMidnight(now);
    const eventMinutes = getMinutesSinceMidnight(eventDateObj);

    // Calculate 7 hours ago in minutes
    const sevenHoursAgo = currentMinutes - 420; // 7 * 60 minutes

    // Ensure the event is today
    if (todayDate !== eventDateFormatted) {
      return false;
    }

    // Return true if the event is within the range from 7 hours ago to the end of today
    return eventMinutes >= sevenHoursAgo;
  };

  const getMinutesSinceMidnight = (date) => {
    return date.getUTCHours() * 60 + date.getUTCMinutes(); // Ensures UTC time handling
  };

  const matchDatabaseData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(base_url + '/api/webapi/matchDatabaseData', {
        headers: { "Content-Type": "application/json" },
      });
      setLockedMatch(response.data.data);
      setLockedMatchesLoaded(true); // Set as loaded
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  }

 const matchData = async () => {
  try {
    const response = await axios.get(base_url + '/api/webapi/matchapi');
    const data = response?.data.result;
    const lockedEventIds = lockedMatch.map(match => match.eventid);

    const allData = [];

    data?.forEach((dta) => {
      const openDate = new Date(dta?.event?.openDate);
      const eventId = dta?.event?.id;
      const isLocked = lockedEventIds.includes(eventId);
      const isLive = openDate < new Date(); // only if openDate is in the past

      if (!isLocked && isLive) {
        allData.push(dta); // push only live & unlocked matches
      }
    });

    return allData;
  } catch (error) {
    console.error("Cricket API Error:", error);
    return [];
  }
};


const footballData = async () => {
  try {
    const response = await axios.get(base_url + '/api/webapi/footballapi');
    const data = response?.data.result;
    const lockedEventIds = lockedMatch.map(match => match.eventid);

    const allData = [];

    data?.forEach((dta) => {
      const openDate = new Date(dta?.event?.openDate);
      const eventId = dta?.event?.id;
      const isLocked = lockedEventIds.includes(eventId);
      const isLive = openDate < new Date(); // match is live

      if (!isLocked && isLive) {
        allData.push(dta); // push only live and unlocked matches
      }
    });

    return allData;
  } catch (error) {
    console.error("Football API Error:", error);
    return [];
  }
};


 const tennisData = async () => {
  try {
    const response = await axios.get(base_url + '/api/webapi/tennisapi');
    const data = response?.data.result;
    const lockedEventIds = lockedMatch.map(match => match.eventid);

    const allData = [];

    data?.forEach((dta) => {
      const openDate = new Date(dta?.event?.openDate);
      const eventId = dta?.event?.id;
      const isLocked = lockedEventIds.includes(eventId);
      const isLive = openDate < new Date(); // match is live

      if (!isLocked && isLive) {
        allData.push(dta); // push only live and unlocked matches
      }
    });

    return allData;
  } catch (error) {
    console.error("Tennis API Error:", error);
    return [];
  }
};

  const loadAllMatchData = async () => {
    setLoading(true);
    try {
      const [cricketMatches, footballMatches, tennisMatches] = await Promise.all([
        matchData(),
        footballData(),
        tennisData()
      ]);

      const allMatches = [...cricketMatches, ...footballMatches, ...tennisMatches];
      setCricket(allMatches);

      const eventIds = allMatches.map(match => match?.event?.id);

      // Now send to backend to fetch live bets
      const response = await axios.post(`${base_url}/admin/fetchLiveMatchBets`,
        { eventIds },
        {
          headers: { "Content-Type": "application/json" }
        }
      );

      const betData = response?.data?.betData;
      setBetCricketMatch(betData);

    } catch (error) {
      console.error("Error loading match data:", error);
    } finally {
      setLoading(false);
    }
  };

  const findLiveMatch = async () => {
    try {
      const eventIds = cricket.map(match => match?.event.id);
      const response = await axios.post(`${base_url}/admin/fetchLiveMatchBets`,
        { eventIds },
        {
          headers: {
            "Content-Type": "application/json",
          },
        })

      const data = response?.data.betData;

      console.log("Data is dkheg,brwliefhp2ouilerfghbjehwgfiyu ", data);
      setBetCricketMatch(data);

    } catch (error) {
      console.error("API Error:", error);
    }
  }

  const findLiveFancyMatch = async () => {
    try {
      const eventIds = cricket.map(match => match?.event.id);
      const response = await axios.post(`${base_url}/admin/fetchFancyLiveMatchBets`,
        { eventIds },
        {
          headers: {
            "Content-Type": "application/json",
          },
        })

      const data = response?.data.betData;
      console.log("responsiefknbbfkjwfhbwjihfkurye sis ", response?.data.betData)
      setBetFancyMatch(data);

    } catch (error) {
      console.error("API Error:", error);
    }
  }

  const handleClick = (item) => {
    console.log(item);
    const [team1, team2] = item.eventName.split(' v ');
    sessionStorage.setItem('marketId', item?.marketId);
    sessionStorage.setItem('eventid', item?.eventId);
    sessionStorage.setItem('competitionname', item?.competitionName);
    sessionStorage.setItem('eventname', item?.eventName);

    if (item.sportname === "cricket") {
      navigate(`/admin/cricket/marketBetAnalysis/${item.marketId}`);
      sessionStorage.setItem('runner1', team1);
      sessionStorage.setItem('runner2', team2);
    } else if (item.sportname === "tennis") {
      navigate(`/admin/tennis/marketBetAnalysis/${item.marketId}`);
      sessionStorage.setItem('runner1', team1);
      sessionStorage.setItem('runner2', team2);
    } else if (item.sportname === "football") {
      navigate(`/admin/football/marketBetAnalysis/${item.marketId}`);
      sessionStorage.setItem('runner1', team1);
      sessionStorage.setItem('runner2', team2);
    }
  }

  const handlefancyClick = (item) => {
    const [team1, team2] = item.eventName.split(' v ');
    sessionStorage.setItem('marketId', item?.marketId);
    sessionStorage.setItem('eventid', item?.eventId);
    sessionStorage.setItem('competitionname', item?.competitionName);
    sessionStorage.setItem('eventname', item?.eventName);

    navigate(`/admin/cricket/marketBetAnalysis/${item.marketId}`);
    sessionStorage.setItem('runner1', team1);
    sessionStorage.setItem('runner2', team2);
  }

  useEffect(() => {
    matchDatabaseData(); // Load database data once on mount
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!lockedMatchesLoaded) return;

      await loadAllMatchData();
      await findLiveMatch();
      await findLiveFancyMatch();
    };

    fetchData();
  }, [lockedMatchesLoaded]);

  // Run findLiveMatch every second ONLY if cricket data is ready
  useEffect(() => {
    if (!lockedMatchesLoaded || !cricket || cricket.length === 0) return;

    const intervalId = setInterval(() => {
      findLiveMatch();
      findLiveFancyMatch()
    }, 1000);

    return () => clearInterval(intervalId); // cleanup
  }, [lockedMatchesLoaded, cricket]);

  // Grouped bet data by eventId and runnerName
  const groupedBetData = betcricketMatch.reduce((acc, bet) => {
    if (!acc[bet.eventId]) acc[bet.eventId] = {};
    if (!acc[bet.eventId][bet.runnerName]) acc[bet.eventId][bet.runnerName] = 0;
    acc[bet.eventId][bet.runnerName] += bet.betAmount;
    return acc;
  }, {});

  const uniqueBetMatches = betcricketMatch.filter(
    (match, index, self) =>
      index === self.findIndex(m => m.eventId === match.eventId)
  );

 // Build team to selectionId mapping
const teamSelectionMap = {};
betcricketMatch.forEach(bet => {
  teamSelectionMap[bet.runnerName] = bet.selectionId;
});

// Build selection sums by eventId and selectionId
const selectionSums = betcricketMatch.reduce((acc, bet) => {
  const { eventId, selectionId, side, betAmount } = bet;

  if (!acc[eventId]) acc[eventId] = {};
  if (!acc[eventId][selectionId]) acc[eventId][selectionId] = { Lay: 0, Back: 0 };

  acc[eventId][selectionId][side] += betAmount;
  return acc;
}, {});


  const selectionProfits = betcricketMatch.reduce((acc, bet) => {
    const { eventId, selectionId, profit } = bet;

    if (!acc[eventId]) acc[eventId] = {};
    if (!acc[eventId][selectionId]) acc[eventId][selectionId] = 0;

    acc[eventId][selectionId] += parseFloat(profit); // Ensure profit is treated as number
    return acc;
  }, {});

  const selectionSideProfit = betcricketMatch.reduce((acc, bet) => {
    const { eventId, selectionId, side, profit } = bet;

    if (!acc[eventId]) acc[eventId] = {};
    if (!acc[eventId][selectionId]) acc[eventId][selectionId] = { lay: 0, back: 0 };

    if (side === 'Lay') {
      acc[eventId][selectionId].lay += parseFloat(profit);
    } else if (side === 'Back') {
      acc[eventId][selectionId].back += parseFloat(profit);
    }

    return acc;
  }, {});

  console.log("fancy betsu dbdi", betfancytMatch)

  const groupedBetsByFancyId = {};

  betfancytMatch.forEach(bet => {
    const { fancyId, side, betAmount } = bet;

    if (!groupedBetsByFancyId[fancyId]) {
      groupedBetsByFancyId[fancyId] = {
        totalBack: 0,
        totalLay: 0,
      };
    }

    if (side === 'yes') {
      groupedBetsByFancyId[fancyId].totalBack += betAmount;
    } else if (side === 'no') {
      groupedBetsByFancyId[fancyId].totalLay += betAmount;
    }
  });

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="wrapper">
      {/* Skeleton CSS Styles */}
      <style jsx>{`
        .skeleton-line {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: skeleton-loading 1.5s infinite;
          border-radius: 4px;
        }

        @keyframes skeleton-loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }

        .skeleton-pulse {
          animation: skeleton-pulse 1.5s ease-in-out infinite;
        }

        @keyframes skeleton-pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }

        .cursor-pointer {
          cursor: pointer;
        }
      `}</style>

      {/* Main Sidebar */}
      <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />

      {/* Header - Pass mobile info */}
      <AdminHeader
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      />

      {/* Content Wrapper - Use conditional class and margin */}
      <div
        className={`content-wrapper d-flex flex-column ${!isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
        style={{
          marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
          transition: "margin-left 0.3s ease"
        }}
      >
        <section className="content mt-2">
          <div className="container-fluid">
            <div className="row">
              {/* Left Column - Fancy Bets */}
              <div className="col-md-6 mb-4">
                <div className="card shadow-sm">
                  <div className="card-header text-white fw-bold" style={{backgroundColor: "#14b09d"}}>
                    Fancy bets
                  </div>
                </div>

                {/* Show skeleton loading for fancy bets */}
                {loading || !lockedMatchesLoaded ? (
                  // Skeleton for fancy bets
                  <>
                    {[...Array(3)].map((_, idx) => (
                      <FancySkeleton key={idx} />
                    ))}
                  </>
                ) : (
                  // Actual fancy bet data
                  betfancytMatch.map((item, idx) => {
                    const [team1, team2] = item.eventName.split(' v ');
                    const betsForEvent = groupedBetData[item.fancyId] || {};
                    const { totalBack, totalLay } = groupedBetsByFancyId[item.fancyId] || { totalBack: 0, totalLay: 0 };

                    return (
                      <div key={idx} className="card mb-3 shadow-sm">
                        <div className="card-header text-white bg-primary fw-bold cursor-pointer" onClick={() => handlefancyClick(item)}>
                          {item.eventName} <span className="fw-normal">(match {item.type})</span>
                        </div>
                        <div className="card-body d-flex justify-content-between fw-bold">
                          <span>{item.runnerName}</span>
                          <span>₹{totalBack + totalLay}</span>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>

              {/* Right Column - Odds And BookMaker Bets */}
              <div className="col-md-6">
                 <div className="card shadow-sm">
                  <div className="card-header text-white fw-bold" style={{backgroundColor: "#14b09d"}}>
                    Odds & Bookmaker bets
                  </div>
                </div>
                {/* Show skeleton loading for bet matches */}
                {loading || !lockedMatchesLoaded ? (
                  // Skeleton for bet matches
                  <>
                    {[...Array(4)].map((_, idx) => (
                      <SkeletonCard key={idx} />
                    ))}
                  </>
                ) : (
                  // Actual bet match data
                 uniqueBetMatches.map((item, idx) => {

                  console.log("item ", item);

                  // console.log("items", item)
  const [team1, team2] = item.eventName.split(' v ');
  const selectionData = selectionSums[item.eventId] || {};
  const sideProfitData = selectionSideProfit[item.eventId] || {};

 const team1SelectionId = teamSelectionMap[item.team1];
 const team2SelectionId = teamSelectionMap[item.team2];
 const foootballTheDraw = teamSelectionMap["The Draw"] || {};
 console.log("dnjnd", foootballTheDraw);

//   console.log("Team 1 Selection ID:", team1SelectionId);
//   console.log("Team 2 Selection ID:", team2SelectionId);

// Lay and Back sums
const laySumTeam1 = parseFloat(selectionData[team1SelectionId]?.Lay || 0);
const backSumTeam1 = parseFloat(selectionData[team1SelectionId]?.Back || 0);
const laySumTeam2 = parseFloat(selectionData[team2SelectionId]?.Lay || 0);
const backSumTeam2 = parseFloat(selectionData[team2SelectionId]?.Back || 0);

const laySumTheDraw = parseFloat(selectionData[foootballTheDraw]?.Lay || 0);
const backSumTheDraw = parseFloat(selectionData[foootballTheDraw]?.Back || 0);

console.log("laysjnjnd", laySumTheDraw);
console.log("bakcnkjnjked", backSumTheDraw);

const overallDrawSum = laySumTheDraw + backSumTheDraw;
console.log("", overallDrawSum)



// console.log("Lay Sum Team 1:", laySumTeam1);
// console.log("Back Sum Team 1:", backSumTeam1);
// console.log("Lay Sum Team 2:", laySumTeam2);
// console.log("Back Sum Team 2:", backSumTeam2);

// Lay and Back profits
const layProfitTeam1 = parseFloat(sideProfitData[team1SelectionId]?.lay || 0);
const backProfitTeam1 = parseFloat(sideProfitData[team1SelectionId]?.back || 0);
const layProfitTeam2 = parseFloat(sideProfitData[team2SelectionId]?.lay || 0);
const backProfitTeam2 = parseFloat(sideProfitData[team2SelectionId]?.back || 0);

// console.log("Lay Profit Team 1:", layProfitTeam1);
// console.log("Back Profit Team 1:", backProfitTeam1);
// console.log("Lay Profit Team 2:", layProfitTeam2);
// console.log("Back Profit Team 2:", backProfitTeam2);

// Final calculated profits
const team1Profit = layProfitTeam1 + backProfitTeam2;
const team2Profit = layProfitTeam2 + backProfitTeam1;

// console.log("Total Profit for Team 1 (Lay1 + Back2):", team1Profit);
// console.log("Total Profit for Team 2 (Lay2 + Back1):", team2Profit);

// Final calculated sums
const team1sum = laySumTeam1 + backSumTeam2;
const team2sum = laySumTeam2 + backSumTeam1;

// console.log("Total Stake Sum for Team 1 (Lay1 + Back2):", team1sum);
// console.log("Total Stake Sum for Team 2 (Lay2 + Back1):", team2sum);


  return (
    <div key={idx} className="card mb-3 shadow-sm" onClick={() => handleClick(item)}>
      <div className="card-header text-white bg-primary fw-bold cursor-pointer">
        {item.eventName} <span className="fw-normal">(match {item.type})</span>
      </div>
      <div className="card-body d-flex justify-content-between fw-bold">
        <span>{item.team1}</span>
        <span className={team1Profit > team1sum ? "text-danger" : "text-success"}>
          ₹{team1Profit.toFixed(2)}
        </span>
      </div>
      <div className="card-body d-flex justify-content-between fw-bold">
        <span>{item.team2}</span>
        <span className={team2Profit > team2sum ? "text-danger" : "text-success" }>
          ₹{team2Profit.toFixed(2)}
        </span>
      </div>

      {item.sportname === "football" && (
  <div className="card-body d-flex justify-content-between fw-bold">
    <span>The Draw</span>
    <span className="text-success">
      ₹{backSumTheDraw}
    </span>
  </div>
)}

      

    </div>
  );
})

                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default MarketAnalysis;